"use client"
import { useState } from "react"
import "../assets/css/contact.css"

export default function ContactForm() {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  return (
    <section id="contact" className="contact-form-container">
      <h2 className="form-title">Contact Us</h2>
      <p className="form-description">
        We'd love to hear from you! Please fill out the form below to get in touch with us.
      </p>

      <form action="https://formsubmit.co/info@gbceylon.com" method="POST" className="contact-form" >
          <div className="form-group">
            <label htmlFor="name">Name*</label>
            <input type="text" name="name" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input type="email" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input type="tel" name="tel" id="phone" />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message*</label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
        </div>

        <div className="form-footer">
          <p className="required-fields">
            <span>*</span> Required fields
          </p>
          <button type="submit" className="submit-button">
            Submit
          </button>
        </div>

        <input type="hidden" name="_next" value="https://greenbeatceylon.com/thank-you" />
        <input type="hidden" name="_captcha" value="false"/>
      </form>
    </section>
  )
}
